import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { CommonModule } from "@angular/common";
import { InputsModule } from "@progress/kendo-angular-inputs";
import { ButtonsModule, KENDO_BUTTONS } from "@progress/kendo-angular-buttons";
import { LabelModule } from "@progress/kendo-angular-label";
import { LayoutModule } from "@progress/kendo-angular-layout";
import { LoggerService } from '../../shared/logger.service';
import { ConcreteCreatorOnId, StoryStatesObj, StoryStateType } from '../../common/status.obj.lib';
import { StoryStates } from '../../common/constants.lib';
import { FormsModule } from '@angular/forms';
import { CasiStoryStatus, CasiStoryStatusParcel, ICasiStoryStatusOptions } from '../../models/models.lib';

// let creator = new ConcreteCreatorOnId(); // new ConcreteCreator();

@Component({
  selector: 'casi-status-button',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    InputsModule,
    ButtonsModule,
    LabelModule,
    LayoutModule,
    KENDO_BUTTONS
  ],
  templateUrl: './status-button.component.html',
  styleUrl: './status-button.component.scss'
})
export class StatusButtonComponent implements OnInit, OnDestroy {
  // private _storyStatusId: number | undefined; // = StoryStatesObj[StoryStates.Unscheduled].id;
  // @Input({ required: true })
  // set storyStatusId(val: number | undefined) {
  //   this._storyStatusId = val;
  //   this.contextStatus = this.creator.factoryMethod(this._storyStatusId);
  //   this.showReject = this._storyStatusId === StoryStatesObj[StoryStates.Delivered].id;
  //   this.logger.debug(`input:storyStatusId: `, this._storyStatusId);
  // }
  // get storyStatusId() {
  //   return (this._storyStatusId as number);
  // }
  private _storyStatus: CasiStoryStatus | undefined; // = StoryStatesObj[StoryStates.Unscheduled].id;
  @Input({ required: true })
  set storyStatus(val: CasiStoryStatus | undefined) {
    this._storyStatus = val;
    if (this._storyStatus) {
      this.contextStatus = <ICasiStoryStatusOptions>this._storyStatus?.next_options[0]; // this.creator.factoryMethod(this._storyStatusId);
      // this.contextStatus = this.creator.factoryMethod(this._storyStatusId);
      this.showReject = this._storyStatus ? this._storyStatus?.next_options.length > 1 : false; // this._storyStatusId === StoryStatesObj[StoryStates.Delivered].id;
      if (this.showReject) {
        this.rejectContextStatus = <ICasiStoryStatusOptions>this._storyStatus?.next_options[1]; // this.creator.factoryMethod(this._storyStatusId);
      }
    }
    this.logger.debug(`input:storyStatus: `, this._storyStatus);
  }
  get storyStatus() {
    return this._storyStatus;
  }
  get storyStatusId() {
    return (this._storyStatus?.id as number);
  }
  @Output() onChange = new EventEmitter<CasiStoryStatusParcel>();

  private creator = new ConcreteCreatorOnId();

  public showReject: boolean = false;
  public contextStatus: ICasiStoryStatusOptions = <ICasiStoryStatusOptions>this.storyStatus?.next_options[0]; // this.creator.factoryMethod(StoryStatesObj[StoryStates.Unscheduled].id);

  public rejectContextStatus: ICasiStoryStatusOptions | undefined = this.showReject === true ? <ICasiStoryStatusOptions>this.storyStatus?.next_options[1] : undefined; // this.creator.factoryMethod(StoryStatesObj[StoryStates.Rejected].id);

  constructor(
    private logger: LoggerService,
  ) { }

  //#region NG Event handlers

  ngOnInit(): void {
    // this.logger.debug('ngOnInit...',);
  }

  ngOnDestroy(): void {
    // this.logger.debug('ngOnDestroy...');
  }

  //#endregion

  public onButtonClick(): void {
    this.logger.debug("onButtonClick", this.storyStatus?.next_options[0]);
    this.onChange.emit(new CasiStoryStatusParcel(this.storyStatus!, this.storyStatus?.next_options[0]!));
    // this.onChange.emit(this.contextStatus.display);
    // this.contextStatus.requestChange();
  }

  public onRejectButtonClick(): void {
    this.logger.debug("onRejectButtonClick", this.storyStatus?.next_options[1]);
    this.onChange.emit(new CasiStoryStatusParcel(this.storyStatus!, this.storyStatus?.next_options[1]!));
    // this.onChange.emit(this.storyStatus?.next_options[1]);
    // this.onChange.emit(this.rejectContextStatus.display);
    // this.contextStatus.requestChange();
  }


}


